<template>
  <div class="parallax-container">
    <ul class="container collapsible">
      <li class="active">
        <TravelSection />
      </li>
      <li>
        <TravelersSection />
      </li>
      <li>
        <SummarySection />
      </li>
    </ul>
    <div class="parallax">
      <img src="../assets/para-2.jpg" alt="Le Gombessa" />
    </div>


  </div>
</template>


<script>
import TravelSection from "@/components/reservation/TravelSection.vue";
import TravelersSection from "@/components/reservation/TravelersSection.vue";
import SummarySection from "@/components/reservation/SummarySection.vue";
import M from "materialize-css";

export default {
  components: {
    TravelSection,
    TravelersSection,
    SummarySection
  },
  mounted() {
    // collapsible, mobile menu
    M.AutoInit();
  }
};
</script>


<style scoped>
@media (max-width: 600px) {
  body .parallax-container {
    background-color: white !important;
  }
}
</style>